export default {"src":"/_next/static/media/grow-skills.69df462c.svg","height":151,"width":478,"blurWidth":0,"blurHeight":0};